import {action, computed, observable} from "mobx"

export default class SignatureStore {

  @observable signatures    = []
  @observable signatureById = new Map()

  constructor(api) {
    this.api = api
    window.signatureStore = this
    api.signals.updated.add( this.setOrder )
  }

  @action
  setOrder = ({ order }) => {
    this.signatures = this.api.order.Steps.filter( s => s.TypeCode === "SignDocument" && s.TrackingId !== "EXTRA_SIG_EXTERNAL_TECH" )
    this.signatures.forEach( signature => {
      this.signatureById.set( signature.Id, signature )
    } )
  }

  @action
  signStep = ({ step }) => {

  }

  @computed
  get signaturesOpen(){
    return this.signatures.filter(s => !s.IsDone)
  }

}





// WEBPACK FOOTER //
// ./src/pages/components/Step/SignatureStore.js